import { Reveal, SectionLabel } from "@/components/Reveal";
import { EMAIL, EMAIL_MAILTO, PHONE_DISPLAY, PHONE_TEL, usePageTitle } from "@/lib/data";

const sections = [
  {
    title: "What we collect",
    body: "Only what you choose to share with us: typically your name (a first name is fine), a way to reach you, and whatever you tell us about your property situation. We do not collect information about you from data brokers, and our website does not use advertising trackers.",
  },
  {
    title: "How we use it",
    body: "Your information is used for one purpose only: to respond to your inquiry and, if you wish, to help you explore resolution options for your property. We will never add you to marketing lists, call repeatedly, or contact you in ways you have not asked for.",
  },
  {
    title: "Confidentiality",
    body: "Every conversation with Property Resolutions Group is confidential. We do not place signs, send mail to your address, or contact neighbors or family members. No one will know you spoke with us unless you tell them.",
  },
  {
    title: "Sharing",
    body: "We never sell, rent, or trade your personal information. If your situation requires a title company, attorney, or lender, we share only what is necessary for that work — and only after discussing it with you.",
  },
  {
    title: "Data security & retention",
    body: "Intake submissions are stored securely and access is limited to our small local team. When a matter is concluded — or if you simply ask — we delete your information.",
  },
  {
    title: "Your choices",
    body: `You may ask us at any time to see, correct, or delete the information you have shared. Email us at ${EMAIL} or call ${PHONE_DISPLAY} and we will take care of it promptly, no questions asked.`,
  },
];

export default function Privacy() {
  usePageTitle("Privacy Policy");
  return (
    <section data-testid="privacy-page" className="pt-44 pb-28">
      <div className="mx-auto max-w-3xl px-6">
        <Reveal>
          <SectionLabel>Privacy Policy</SectionLabel>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-night leading-tight">
            Your privacy is the whole point.
          </h1>
          <p className="mt-6 text-charcoal leading-relaxed text-lg">
            Effective July 2026. This policy explains, in plain language, how Property Resolutions Group
            ("PRG") handles the information you share with us.
          </p>
        </Reveal>
        <div className="mt-14 space-y-12">
          {sections.map((s) => (
            <Reveal key={s.title}>
              <h2 className="font-serif text-2xl sm:text-3xl text-night">{s.title}</h2>
              <p className="mt-4 text-charcoal leading-relaxed">{s.body}</p>
            </Reveal>
          ))}
          <Reveal>
            <h2 className="font-serif text-2xl sm:text-3xl text-night">Contact us about privacy</h2>
            <p className="mt-4 text-charcoal leading-relaxed">
              Questions about this policy? Reach us at{" "}
              <a href={EMAIL_MAILTO} data-testid="privacy-email-link" className="text-sage-deep underline underline-offset-4 hover:text-night transition-colors duration-300">{EMAIL}</a>{" "}
              or{" "}
              <a href={PHONE_TEL} data-testid="privacy-phone-link" className="text-sage-deep underline underline-offset-4 hover:text-night transition-colors duration-300">{PHONE_DISPLAY}</a>.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
